import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFingerprint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M27.614 53.06q.053-.089.109-.177A27.83 27.83 0 0 0 32 38a8 8 0 1 1 16 0c0 2.034-.139 4.037-.407 6m-4.235 13.687A43.8 43.8 0 0 0 46.341 50m7.678 2.264A52 52 0 0 0 56 38c0-8.837-7.163-16-16-16-2.914 0-5.647.78-8 2.14M22 46.729A19.9 19.9 0 0 0 24 38c0-2.914.78-5.647 2.14-8M40 38a35.83 35.83 0 0 1-5.506 19.142"
    />
  </svg>
);
export default SvgFingerprint;
